import { GenericMessageResponse } from "@app/app.interface";
import { PortfolioCreationType } from "@app/_shared/modules/portfolio-form/portfolio-form.enums";
import { SearchSymbolResults } from '../symbol-search';
import { MarketKeywords } from "@app/app.structs";

export interface ExecutePortfolioRequest {
    state: number,
    multiplier?: number,
    running_type?: number,
    unique_portfolio_id?: String,
    margin_required?: number;
    min_cash_required?: number;
    user_confirmation?: boolean;
    autoDeployPortfolio?: boolean;
    strategiesToUpdate?: string[];
    portfolioID?: string;
    to_retain_multiplier?: boolean;
    broker?: string;
    broker_id?: string;
    space_id?: string;
    regulatory_confirmation?: boolean
}

export interface ExecutePortfolioResponse {
    message: string;
    error?: string;
    errorCode?: number;
    status?: string;
    type?: string;
    userConfirmationRequired?: boolean;
    amdDeployed?: boolean;
    Symbols?: string[];
    StartDate?: number;
    EndDate?: number;
    StartTime?: number;
}

export interface ExecutePanicControlResponse extends GenericMessageResponse {
    portfolioIDs: String[];
    userConfirmationRequired?: boolean;
    effected_portfolios?: string[];
}

export interface PortfolioPayoffCurveObj {
    portfolioId: string;
    portfolioName: string;
    strategies: StrategyPayoffObj[];
    exchange?: string;
}


export interface StrategyPayoffObj {
    strategyName: string;
    underLyingType?: string;
    symbol?: SearchSymbolResults;
    legs: LegPayoffObj[];
}

export interface LegPayoffObj {
    orderMode: number;
    symbol: SearchSymbolResults;
    lots: number;
    price?: number;
}

export interface RunBacktestRequest {
    strategy_index: number;
    initial_capital: number;
    start_date: number;
    end_date: number;
    token_id?: number;
    multiplier?: number;
    isPortfolio: boolean;
}

export interface PreBacktestRequest {
    algo_name: String;
    start_date: number;
    end_date: number;
    initial_capital: number;
    portfolio_creation_type: PortfolioCreationType;
    is_portfolio: boolean;
}

export interface SquareOffPortfolioRequest {
    unique_portfolio_id: string;
    strategies?: string[];
    cancel_auto_square_off?: boolean;
    user_confirmation?: boolean;
}

export interface AutoDeploymentDetails {
    autoDeployPortfolio: boolean,
    autoDeploymentDays: number[],
    portfolioID: string,
    timestamp: number,
    deleteTime: number,
    runningType: number,
    portfolioCreationType: number,
    originalPortfolioID: string,
    multiplier: number
}

export interface AutoDeploymentStreamPayload{
    autoDeploymentDetails: AutoDeploymentDetails;
    market_id: MarketKeywords;
}

export interface RegulationResponse {
    regulatory_data: RegulatoryData[];
}

export interface RegulatoryData {
    company_name: string,
    symbol: string,
    regulatory_messages: string[],
}
